'use client';
import React, { useState } from 'react';
import { Search, Check, X, Trash2, Pencil } from 'lucide-react';
export default function NewsCommentsManagers() {
  const [comments, setComments] = useState([
    {
      id: 1,
      newsItem: 'About routekart',
      customer: 'admin@yourStore.com',
      commentTitle: 'Sample comment title',
      commentText: 'This is a sample comment text.',
      approved: true,
      createdOn: '02/11/2025 10:34:46 PM',
    },
    {
      id: 2,
      newsItem: 'routekart new release!',
      customer: 'admin@yourStore.com',
      commentTitle: 'Sample comment title',
      commentText: 'This is a sample comment text.',
      approved: true,
      createdOn: '02/11/2025 10:34:46 PM',
    },
    {
      id: 3,
      newsItem: 'New online store is open!',
      customer: 'admin@yourStore.com',
      commentTitle: 'Sample comment title',
      commentText: 'This is a sample comment text.',
      approved: true,
      createdOn: '02/11/2025 10:34:46 PM',
    },
  ]);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const handleAction = (action) => {
    setSelectedAction(action);
    setShowDialog(true);
  };
  const confirmAction = () => {
    if (selectedAction === 'Delete selected') {
      setComments([]);
    }
    setShowDialog(false);
    alert(`✅ ${selectedAction} performed successfully!`);
  };
  const handleDelete = (id) => {
    setDeleteId(id);
    setSelectedAction('Delete single');
    setShowDialog(true);
  };
  const confirmDelete = () => {
    if (deleteId !== null) {
      setComments((prev) => prev.filter((c) => c.id !== deleteId));
      setDeleteId(null);
      setShowDialog(false);
      alert('🗑️ Comment deleted permanently!');
    }
  };
  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-semibold mb-4 text-gray-800">News comments</h1>
      {/* Action Buttons */}
      <div className="flex flex-wrap gap-3 mb-4">
        <button
          onClick={() => handleAction('Approve selected')}
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md flex items-center gap-2"
        >
          <Check size={18} /> Approve selected
        </button>
        <button
          onClick={() => handleAction('Disapprove selected')}
          className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md flex items-center gap-2"
        >
          <X size={18} /> Disapprove selected
        </button>
        <button
          onClick={() => handleAction('Delete selected')}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md flex items-center gap-2"
        >
          <Trash2 size={18} /> Delete selected
        </button>
      </div>
      {/* Search Section */}
      <div className="bg-white shadow-sm rounded-lg p-4 mb-6">
        <h2 className="text-lg font-medium mb-3 flex items-center gap-2">
          <Search size={20} /> Search
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Created from</label>
            <input type="date" className="border rounded-md w-full px-3 py-2 text-sm" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Created to</label>
            <input type="date" className="border rounded-md w-full px-3 py-2 text-sm" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Approved</label>
            <select className="border rounded-md w-full px-3 py-2 text-sm">
              <option>All</option>
              <option>Approved</option>
              <option>Disapproved</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Message</label>
            <input
              type="text"
              placeholder="Enter message"
              className="border rounded-md w-full px-3 py-2 text-sm"
            />
          </div>
        </div>
        <button className="mt-4 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md flex items-center gap-2">
          <Search size={18} /> Search
        </button>
      </div>
      {/* Table */}
      <div className="bg-white shadow-sm rounded-lg overflow-x-auto">
        <table className="w-full text-sm text-left border">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3"><input type="checkbox" /></th>
              <th className="p-3">News item</th>
              <th className="p-3">Customer</th>
              <th className="p-3">Comment title</th>
              <th className="p-3">Comment text</th>
              <th className="p-3">Is approved</th>
              <th className="p-3">Created on</th>
              <th className="p-3">Edit</th>
              <th className="p-3">Delete</th>
            </tr>
          </thead>
          <tbody>
            {comments.length === 0 ? (
              <tr>
                <td colSpan="9" className="text-center p-4 text-gray-500">
                  No comments available.
                </td>
              </tr>
            ) : (
              comments.map((item) => (
                <tr key={item.id} className="border-t hover:bg-gray-50">
                  <td className="p-3">
                    <input type="checkbox" />
                  </td>
                  <td className="p-3 text-blue-600 hover:underline">{item.newsItem}</td>
                  <td className="p-3">{item.customer}</td>
                  <td className="p-3">{item.commentTitle}</td>
                  <td className="p-3 text-gray-600">{item.commentText}</td>
                  <td className="p-3 text-center">
                    {item.approved ? (
                      <Check size={18} className="text-blue-600 inline" />
                    ) : (
                      <X size={18} className="text-red-600 inline" />
                    )}
                  </td>
                  <td className="p-3">{item.createdOn}</td>
                  <td className="p-3">
                    <button className="flex items-center gap-1 text-gray-700 hover:text-blue-600">
                      <Pencil size={16} /> Edit
                    </button>
                  </td>
                  <td className="p-3">
                    <button
                      onClick={() => handleDelete(item.id)}
                      className="flex items-center gap-1 text-red-600 hover:text-red-800"
                    >
                      <Trash2 size={16} /> Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <div className="flex flex-wrap justify-between items-center p-3 text-sm">
          <div>
            Show
            <select className="border rounded-md mx-2 px-2 py-1">
              <option>15</option>
              <option>30</option>
              <option>50</option>
            </select>
            items
          </div>
          <div>{comments.length > 0 ? `1–${comments.length} of ${comments.length} items` : ''}</div>
        </div>
      </div>
      {/* Confirmation Dialog */}
      {showDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-80">
            <h3 className="text-lg font-semibold mb-2">Are you sure?</h3>
            <p className="text-gray-600 mb-4">
              {selectedAction === 'Delete single'
                ? 'Are you sure you want to delete this comment?'
                : 'Are you sure you want to perform this action?'}
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowDialog(false);
                  setDeleteId(null);
                }}
                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={
                  selectedAction === 'Delete single'
                    ? confirmDelete
                    : confirmAction
                }
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
